import type { ApiClient } from '../types/api-client.ts';

/**
 * Chiede conferma e cancella la delega (il server accetta solo BOZZA e DA_PRESENTARE).
 * @returns true se la delega è stata cancellata
 */
export async function confermaCancellaDelega(api: ApiClient, id: number, nome?: string): Promise<boolean> {
  const domanda = nome ? `Cancellare la delega di ${nome}?` : 'Vuoi cancellare questa delega?';
  const ok = await Weext.confirm(domanda, {
    title: 'Conferma cancellazione',
    confirmText: 'Cancella',
    confirmClass: 'btn-danger',
  });
  if (!ok) return false;

  const result = await api.deleghe.elimina(id);
  if (!result.ok) {
    Weext.toast(result.error, { type: 'danger' });
    return false;
  }
  Weext.toast('Delega cancellata', { type: 'success' });
  return true;
}
